import { render, staticRenderFns } from "./Addspecial.vue?vue&type=template&id=ec66eaca&"
import script from "./Addspecial.vue?vue&type=script&lang=js&"
export * from "./Addspecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports